import createIcon from '../../createIcon';

/**
 * @component @name AdfScanner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTJIMThWNEg2VjEySDVDMy4zNCAxMiAyIDEzLjM0IDIgMTVWMjBIMjJWMTVDMjIgMTMuMzQgMjAuNjYgMTIgMTkgMTJaTTE2IDEySDhWNkgxNlYxMlpNMTggMTdDMTcuNDUgMTcgMTcgMTYuNTUgMTcgMTZDMTcgMTUuNDUgMTcuNDUgMTUgMTggMTVDMTguNTUgMTUgMTkgMTUuNDUgMTkgMTZDMTkgMTYuNTUgMTguNTUgMTcgMTggMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AdfScanner = createIcon('AdfScanner', [
  [
    'path',
    {
      d: 'M19 12H18V4H6V12H5C3.34 12 2 13.34 2 15V20H22V15C22 13.34 20.66 12 19 12ZM16 12H8V6H16V12ZM18 17C17.45 17 17 16.55 17 16C17 15.45 17.45 15 18 15C18.55 15 19 15.45 19 16C19 16.55 18.55 17 18 17Z',
      key: 'e9v19z',
    },
  ],
]);

export default AdfScanner;
